module.exports = __webpack_public_path__ + "static/img/fourth3.f169aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fourth3.png
// module id = MP46
// module chunks = 25